export function deepClone<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj ?? null)) ?? {}
}

export function isNullOrUndefined(value: any): boolean {
  return value === null || typeof value === 'undefined'
}

export function valueIfNotBlank(value: string): string {
  if (isNullOrUndefined(value) || value == '') {
    return null
  }
  return value
}

export function presence<T>(value: T): T {
  if (
    !value ||
    (Array.isArray(value) && value.length == 0) ||
    (typeof value == 'object' && Object.keys(value).length == 0)
  ) {
    return null
  }
  return value
}
